// Per-property enriched mock data used by the Property Detail page.
// Keyed by the property ID returned by /api/properties.

export const PROPERTY_DETAILS = {
  "prop-london-gresham": {
    hero_image: "https://images.unsplash.com/photo-1554435493-93422e8220c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    target_yield_pct: 7.5,
    tenants: [
      { name: "HSBC Bank Plc", grade: "AAA (Investment Grade)", expiry: "2036", share_pct: 45 },
      { name: "Deloitte LLP", grade: "AA+", expiry: "2032", share_pct: 35 },
      { name: "Costa Coffee", grade: "A-", expiry: "2029", share_pct: 20 },
    ],
    waterfall: {
      gross_rent: 52000,
      ops_deduction: 4500,
      platform_fee: 750,
      net_yield: 46750,
    },
    highlights: [
      "Grade A office asset in the heart of the City of London",
      "40s to Bank Station · 2 min from the Bank of England",
      "Weighted Average Unexpired Lease Term (WAULT) 9.2 years",
      "EPC Rating B · BREEAM Very Good",
    ],
  },
  "prop-manchester-arndale": {
    hero_image: "https://images.pexels.com/photos/1005638/pexels-photo-1005638.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    target_yield_pct: 8.5,
    tenants: [
      { name: "JD Sports Plc", grade: "A+", expiry: "2033", share_pct: 40 },
      { name: "Boots UK Ltd", grade: "AA-", expiry: "2030", share_pct: 35 },
      { name: "Pret A Manger", grade: "BBB+", expiry: "2028", share_pct: 25 },
    ],
    waterfall: {
      gross_rent: 34000,
      ops_deduction: 3800,
      platform_fee: 450,
      net_yield: 29750,
    },
    highlights: [
      "Prime retail block within the Manchester Arndale destination",
      "42 million annual footfall · #1 UK shopping centre by visits",
      "Multi-let to national high street covenants · WAULT 5.4 years",
      "Strong RPI-linked rent reviews on all leases",
    ],
  },
  "prop-birmingham-logistics": {
    hero_image: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    target_yield_pct: 9.5,
    tenants: [
      { name: "DHL Supply Chain", grade: "AA", expiry: "2038", share_pct: 55 },
      { name: "Amazon Logistics UK", grade: "AA+", expiry: "2035", share_pct: 30 },
      { name: "XPO Logistics", grade: "BBB+", expiry: "2030", share_pct: 15 },
    ],
    waterfall: {
      gross_rent: 75000,
      ops_deduction: 6200,
      platform_fee: 950,
      net_yield: 67850,
    },
    highlights: [
      "Institutional-grade last-mile logistics warehouse",
      "Junction 6 M42 corridor · 4-hour reach to 90% of UK population",
      "Blue-chip 3PL covenant · RPI-linked lease · WAULT 12.1 years",
      "EPC A · Solar-ready roof · 15m eaves height",
    ],
  },
};

export const getPropertyDetail = (id) =>
  PROPERTY_DETAILS[id] || PROPERTY_DETAILS["prop-london-gresham"];
